// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @08.08.2019 07:18:41
import { PersistentObject } from '../../SagaBase/PersistentObject';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class ResourcePositionHistory_abstract extends PersistentObject {
  static $t: string = 'SagaSchema.ResourcePositionHistory';
  $t: string = 'SagaSchema.ResourcePositionHistory';

  public static GetMembers(): string[] {
    return ['Owner', 'CreatedUtc', 'Id', 'MapX', 'MapY', 'CoordEpsgCode', 'ResourceGuid', 'UnitActivityUId'].concat(
      PersistentObject.GetMembers()
    );
  }

  public GetMembers(): string[] {
    return ResourcePositionHistory_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    this.CreatedUtc = this.CreatedUtc && new Date(this.CreatedUtc);

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public Owner: number = 0;
  public CreatedUtc: Date = new Date();
  public Id: number = 0;
  public MapX: number = 0;
  public MapY: number = 0;
  public CoordEpsgCode: string;
  public ResourceGuid: Guid = GuidTools.Empty;
  public UnitActivityUId: Guid = GuidTools.Empty;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
